// src/components/duty/dutyTokens.ts — palette + fonts for the Sign-In net-new
// surfaces (duty card, sign-in sheet, declaration modal, lone-working panel).
//
// Decision 3: the prototype is authoritative for these net-new surfaces, so the
// duty/brass shades are the literal hex from docs/build-plan/sign-in-system/
// slices/theme.jsx (not the runtime-themed C.* CSS vars used by existing chrome).
// Colour lanes are strict: sage #4F6852 = duty; brass = the Lone Working /
// "still on duty?" safety nudges. Never royal blue (that is 1:1 QM).

import { F } from "../../theme";

export const D = {
  page: "#FBF6E8",
  card: "#FFFFFF",
  ink: "#2B2014",
  inkSoft: "#604C32",
  inkMute: "#9F8B6B",
  hairline: "#E8DCBC",

  // brass — signed-out CTA + Lone Working / reminder nudges
  brass: "#A6771C",
  brassDk: "#7A540B",
  brassLt: "#D9B466",
  brassGlow: "#F4E2A8",
  brassBg: "#FBEFCB",
  brassSurf: "#FFF6DC",

  // duty — deep sage
  duty: "#4F6852",
  dutyDk: "#364B3A",
  dutyLt: "#B0C3B3",
  dutyBg: "#E4ECDF",
  dutySurf: "#EFF4EB",
  dutyGlow: "#C8DACC",
} as const;

export const DF = {
  serif: F.serif,
  body: F.body,
  mono: F.mono,
} as const;

// Pulsing-dot keyframes used by the duty card + lone-working "on" indicator.
// Rendered once via a <style> tag inside DutySurface.
export const DUTY_KEYFRAMES = `
@keyframes dutyPulse { 0% { box-shadow: 0 0 0 0 rgba(79,104,82,0.45);} 70% { box-shadow: 0 0 0 8px rgba(79,104,82,0);} 100% { box-shadow: 0 0 0 0 rgba(79,104,82,0);} }
@keyframes lwPulse { 0% { box-shadow: 0 0 0 0 rgba(122,84,11,0.5);} 70% { box-shadow: 0 0 0 7px rgba(122,84,11,0);} 100% { box-shadow: 0 0 0 0 rgba(122,84,11,0);} }
`;

export function formatClock(date: Date): string {
  return date.toLocaleTimeString("en-GB", { hour12: false });
}

export function formatDuration(totalMinutes: number): string {
  const h = Math.floor(totalMinutes / 60);
  const m = totalMinutes % 60;
  return `${String(h).padStart(2, "0")}h ${String(m).padStart(2, "0")}m`;
}

export function formatLongDate(date: Date): string {
  return date.toLocaleDateString("en-GB", { weekday: "long", day: "numeric", month: "long" });
}
